/** English copy for the home dashboard (2026-08-05; redesigned 2026-10-30). See `es.ts`. */
export const DASHBOARD_LOCALE_EN = {
  DASHBOARD: {
    TITLE: 'Dashboard',
    GREETING: {
      MORNING: 'Good morning',
      AFTERNOON: 'Good afternoon',
      EVENING: 'Good evening',
    },
    SUMMARY: '{{ greeting }}, {{ name }}. Summary for {{ weekday }} {{ date }}.',
    SUMMARY_NO_NAME: '{{ greeting }}. Summary for {{ weekday }} {{ date }}.',
    TODAY: {
      TITLE: "Today's figures",
      BOOKINGS: "Today's bookings",
      YESTERDAY: '{{ count }} yesterday',
      PENDING: 'Awaiting payment',
      PENDING_LINK: 'See pending',
      REVENUE: "Today's paid sales",
      REVENUE_NOTE: 'From bookings created and paid today.',
      CALLS: 'Failed calls to Hotelbeds today (UTC)',
      CALLS_OF: 'of {{ total }}',
      CALLS_LINK: 'See calls',
      ERROR: "We could not load today's figures.",
    },
    ATTENTION: {
      TITLE: 'Needs your attention',
      SUBTITLE: 'Bookings in a state that will not resolve on its own. Counts all history, not just the date range below.',
      ALL_CLEAR: 'Nothing pending: no booking needs intervention.',
      OTHERS_CLEAR: 'Nothing pending in {{buckets}}.',
      AND: 'and',
      SEE_ALL: 'See in Bookings',
      GUEST: 'Guest',
      NO_REFERENCE: 'no reference',
      BADGE_ACTION: 'Action needed',
      BADGE_WAITING: 'Waiting',
      BADGE_INFO: 'To review',
      BADGE_REFUNDED: 'Refunded',
      BADGE_EXPIRED: 'Expired',
      FAILED: 'Failed payments',
      FAILED_HINT: 'There may be a charge without a confirmed booking.',
      PARTIALLY_CONFIRMED: 'Confirmation to review',
      PARTIALLY_CONFIRMED_HINT: 'Some rooms were not confirmed. Check the status in Hotelbeds before retrying.',
      PENDING_PAYMENT: 'Awaiting payment',
      PENDING_PAYMENT_HINT: 'Waiting for the customer to pay. They expire on their own after 24 hours unpaid.',
      REFUNDED: 'Refunded',
      REFUNDED_HINT: 'Check the reason and whether the customer must be told.',
      NOTE_FAILED_REFUNDED: 'Failed with the payment already refunded: {{ count }}. No charge without a booking.',
      NOTE_EXPIRED_PENDING: 'Expired unpaid: {{ count }}. They can no longer be paid and need nothing.',
      ERROR_TITLE: 'We could not load what needs your attention',
      ERROR_DESC: 'We do not know whether bookings are pending. Reload the page in a moment.',
    },
    HEALTH: {
      CONTENT_TITLE: 'Hotelbeds content',
      CONTENT_NOTE: 'The website reads this local copy: content is not requested from Hotelbeds during a booking. Times in your local time.',
      CATALOG_STATE: {
        HEALTHY: 'Up to date',
        DEGRADED: 'With warnings',
        STALLED: 'Stalled',
        FAILING: 'Failing',
        NEVER_SUCCEEDED: 'Never synced',
      },
      SYSTEM_TITLE: 'Connection and exchange rates',
      LOAD_ERROR: 'We could not load this status. Reload the page in a moment.',
      PROVIDER: 'Connection to Hotelbeds',
      PROVIDER_OK: 'Connected',
      PROVIDER_KO: 'Disconnected',
      CATALOG_HOTELS: 'Stored hotels',
      CATALOG_LAST_SUCCESS: 'Last successful sync',
      CATALOG_FAILED: 'Failed destinations',
      CATALOG_LINK: 'Go to the catalogue',
      NEVER: 'Never',
      FX: 'Active exchange rates',
      FX_NONE_BADGE: 'None',
      FX_NONE: 'Without active exchange rates we cannot sell outside the provider currency.',
      FX_DAYS: '{{ days }} days ago',
      FX_NO_DATE: 'no date',
      FX_STALE_HINT: 'An outdated rate affects every selling price.',
      FX_PAIRS: '{{count}} pairs',
      FX_LINK: 'Manage exchange rates',
    },
  },
};
